<template>
  <sources-form
    :source="source"
    :source-collections="sourceCollections"
    :collections="collections"
    :custom-parsers="customParsers"
  ></sources-form>
</template>

<script>
export default {
  props: ['source', 'sourceCollections', 'collections', 'customParsers']
};
</script>
